export default __webpack_public_path__ + "static/media/Hero.ad18f547.mp4";